module.exports = __webpack_public_path__ + "images/contact-inviter-visual.178098d9.jpg";